import { createSelector } from 'reselect';

const selectGlobalLoops = (state: any) => state.globalLoops;


export const selectGlobalLoopsCurrentItem = createSelector([selectGlobalLoops], (globalLoops) => globalLoops.current);

export const selectGlobalLoopsListItems = createSelector([selectGlobalLoops], (globalLoops) => globalLoops.list);

export const selectGlobalLoopsItemById = (itemId: any) =>
    createSelector(selectGlobalLoopsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectGlobalLoopsQueryItems = createSelector([selectGlobalLoops], (globalLoops) => globalLoops.query);

export const selectGlobalLoopsCreatedItem = createSelector([selectGlobalLoops], (globalLoops) => globalLoops.create);

export const selectGlobalLoopsUpdatedItem = createSelector([selectGlobalLoops], (globalLoops) => globalLoops.update);

export const selectGlobalLoopsReadItem = createSelector([selectGlobalLoops], (globalLoops) => globalLoops.read);

export const selectGlobalLoopsDeletedItem = createSelector([selectGlobalLoops], (globalLoops) => globalLoops.delete);

export const selectGlobalLoopsSearchedItems = createSelector([selectGlobalLoops], (globalLoops) => globalLoops.search);

export const selectGlobalLoopsItemsCount = createSelector([selectGlobalLoops], (globalLoops) => globalLoops.count);

export const selectGlobalLoopsItemsFilter = createSelector([selectGlobalLoops], (globalLoops) => globalLoops.filter);